module.exports = __webpack_public_path__ + "media/a2.7bbfd241.mp3";